import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withRouter from 'react-router/es/withRouter';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node
};

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/common/jsx/layout/ScrollToTop.js